/* tslint:disable */
/* eslint-disable */
/**
 * OneAir.AdminPortal
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: v1
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface CriteriaForLocationRequest
 */
export interface CriteriaForLocationRequest {
    /**
     * 
     * @type {string}
     * @memberof CriteriaForLocationRequest
     */
    stationCode?: string | null;
    /**
     * 
     * @type {string}
     * @memberof CriteriaForLocationRequest
     */
    cityCode?: string | null;
    /**
     * 
     * @type {string}
     * @memberof CriteriaForLocationRequest
     */
    regionCode?: string | null;
    /**
     * 
     * @type {string}
     * @memberof CriteriaForLocationRequest
     */
    countryCode?: string | null;
    /**
     * 
     * @type {boolean}
     * @memberof CriteriaForLocationRequest
     */
    isOutboundArrival?: boolean;
    /**
     * 
     * @type {boolean}
     * @memberof CriteriaForLocationRequest
     */
    isOutboundDeparture?: boolean;
    /**
     * 
     * @type {boolean}
     * @memberof CriteriaForLocationRequest
     */
    exclude?: boolean;
    /**
     * 
     * @type {boolean}
     * @memberof CriteriaForLocationRequest
     */
    isInboundArrival?: boolean;
    /**
     * 
     * @type {boolean}
     * @memberof CriteriaForLocationRequest
     */
    isInboundDeparture?: boolean;
}

export function CriteriaForLocationRequestFromJSON(json: any): CriteriaForLocationRequest {
    return CriteriaForLocationRequestFromJSONTyped(json, false);
}

export function CriteriaForLocationRequestFromJSONTyped(json: any, ignoreDiscriminator: boolean): CriteriaForLocationRequest {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        
        'stationCode': !exists(json, 'stationCode') ? undefined : json['stationCode'],
        'cityCode': !exists(json, 'cityCode') ? undefined : json['cityCode'],
        'regionCode': !exists(json, 'regionCode') ? undefined : json['regionCode'],
        'countryCode': !exists(json, 'countryCode') ? undefined : json['countryCode'],
        'isOutboundArrival': !exists(json, 'isOutboundArrival') ? undefined : json['isOutboundArrival'],
        'isOutboundDeparture': !exists(json, 'isOutboundDeparture') ? undefined : json['isOutboundDeparture'],
        'exclude': !exists(json, 'exclude') ? undefined : json['exclude'],
        'isInboundArrival': !exists(json, 'isInboundArrival') ? undefined : json['isInboundArrival'],
        'isInboundDeparture': !exists(json, 'isInboundDeparture') ? undefined : json['isInboundDeparture'],
    };
}

export function CriteriaForLocationRequestToJSON(value?: CriteriaForLocationRequest | null): any {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        
        'stationCode': value.stationCode,
        'cityCode': value.cityCode,
        'regionCode': value.regionCode,
        'countryCode': value.countryCode,
        'isOutboundArrival': value.isOutboundArrival,
        'isOutboundDeparture': value.isOutboundDeparture,
        'exclude': value.exclude,
        'isInboundArrival': value.isInboundArrival,
        'isInboundDeparture': value.isInboundDeparture,
    };
}


